import { render } from "./ClienteList.vue?vue&type=template&id=39669e20&scoped=true"
import script from "./ClienteList.vue?vue&type=script&lang=js"
export * from "./ClienteList.vue?vue&type=script&lang=js"

import "./ClienteList.vue?vue&type=style&index=0&id=39669e20&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39669e20"]])

export default __exports__